import http from '@/plugins/http';
import reportError from '@/utils/reportError';
import studentJobDetailTransformer from '../../transformers/job/studentJobDetail';

// When the request succeeds
const success = (response, successCallback) => {
  response = studentJobDetailTransformer.fetch(response);
  successCallback(response);
};

// When the request fails
const failed = () => {
};

export default (jobId, userJobId, successCallback) => {
  http.get(`customer/me/jobs/${jobId}/students/${userJobId}`)
    .then((response) => {
      success(response.data, successCallback);
    })
    .catch((error) => {
      reportError(error, 'error trying to post student feedback for a specific job');
      failed(error);
    });
};
